/**
 * Storage key for persisted color mode preference.
 */
export const COLOR_MODE_STORAGE_KEY = 'settings.colorMode';

/**
 * Storage key for persisted split-view enablement preference.
 */
export const SPLIT_VIEW_ENABLED_STORAGE_KEY = 'settings.splitViewEnabled';
export const CUSTOM_FIELDS_MANAGER_DEFAULT_FIELDS_VISIBLE_STORAGE_KEY =
	'settings.customFieldsManager.showDefaultFields';
export const PREFERRED_DATE_FORMAT_STORAGE_KEY = 'preferredDateFormat';
export const PREFERRED_NAME_FORMAT_STORAGE_KEY = 'preferredNameFormat';
export const PREFERRED_TIME_ZONE_STORAGE_KEY = 'preferredTimeZone';
export const PREFERRED_CLOCK_FORMAT_STORAGE_KEY = 'preferredClockFormat';

/**
 * Storage key for DataList UI preferences.
 */
export const DATA_LIST_PREFERENCES_STORAGE_KEY = 'ui.dataList.preferences';
/**
 * Storage key for files table UI preferences.
 */
export const FILES_TABLE_PREFERENCES_STORAGE_KEY = 'ui.filesTable.preferences';
/**
 * Storage key for split panel width preferences.
 */
export const SPLIT_PANEL_WIDTHS_STORAGE_KEY = 'ui.splitPanel.widths';
/**
 * Storage key for advanced filter layout mode preferences.
 */
export const ADVANCED_FILTER_LAYOUTS_STORAGE_KEY = 'ui.advancedFilterLayouts';
/**
 * Storage key for advanced filter collapse-state preferences.
 */
export const ADVANCED_FILTER_COLLAPSE_STORAGE_KEY = 'ui.advancedFilterCollapse';
/**
 * Storage key for split route memory preferences.
 */
export const SPLIT_ROUTE_MEMORY_STORAGE_KEY = 'ui.splitRoute.memory';

/**
 * Debounce interval for UI preference sync calls.
 */
export const UI_PREFERENCES_SYNC_DEBOUNCE_MS = 800;

export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const DEFAULT_NAME_FORMAT = 'FirstName + LastName';
export const DEFAULT_TIME_ZONE = 'UTC';
export const DEFAULT_CLOCK_FORMAT = '12-Hour';
